import { PayloadAction } from '@reduxjs/toolkit';
import * as Actions from './'
import { ApiEnvironment } from '~/@types/index';

export const setEnvironment = (payload: ApiEnvironment): PayloadAction<ApiEnvironment> => {
	return { type: Actions.API_UPDATE_ENVIRONMENT_REQUESTED, payload }
}
